import axios from 'axios';
import AccountsService from '../../services/AccountsService';
import AuthService from '../../services/AuthService';

export const namespaced = true;

export const state = {
  user: null,
  accountMembers: [],
  userJwt: '',
};

export const mutations = {
  SET_JWT(state, jwt) {
    state.userJwt = jwt;
    localStorage.setItem('userJwt', jwt);
    // eslint-disable-next-line dot-notation
    axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
  },
  SET_USER_DATA(state, userData) {
    state.user = userData;
    localStorage.setItem('user', JSON.stringify(userData));
  },
  SET_ACCOUNT_MEMBERS(state, accountMembers) {
    state.accountMembers = accountMembers;
  },
  CLEAR_USER_DATA() {
    localStorage.removeItem('user');
    localStorage.removeItem('userJwt');
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  },
};

export const actions = {
  getAccountMembers({ commit }) {
    return AccountsService.getAccountMembers().then(({ data }) => {
      commit('SET_ACCOUNT_MEMBERS', data);
    });
  },
  register({ dispatch }, {
    email, phoneNumber, firstName, lastName, password,
  }) {
    return AccountsService.create({
      email: email.trim(),
      phoneNumber: phoneNumber.trim(),
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      password,
    }).then(() => dispatch('login', { email: email.trim(), password }));
  },
  inviteUser({ dispatch }, {
    email, phoneNumber, firstName, lastName, role,
  }) {
    return AccountsService.inviteUser({
      email: email.trim(),
      phoneNumber: phoneNumber.trim(),
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      role,
    }).then(() => dispatch('getAccountMembers'));
  },
  completeInvite({ dispatch }, { userId, inviteCode, password }) {
    return AccountsService.completeInvite({
      userId,
      inviteCode,
      password,
    }).then(({ data }) => dispatch('login', {
      email: data.email,
      password,
    }));
  },
  removeUser({ state, commit }, { userId }) {
    return AccountsService.removeUser({ userId })
      .then(() => {
        const remainingAccountMembers = state.accountMembers
          .filter(accountMember => accountMember.id !== userId);
        commit('SET_ACCOUNT_MEMBERS', remainingAccountMembers);
      });
  },
  login({ commit }, { email, password }) {
    return AuthService.login({
      email: email.trim(),
      password,
    }).then(({ data }) => {
      // eslint-disable-next-line camelcase
      const { access_token } = data;
      commit('SET_JWT', access_token);
      return AuthService.getProfile();
    }).then(({ data }) => {
      commit('SET_USER_DATA', data);
    });
  },
  forgottenPassword(_, email) {
    return AccountsService.forgottenPassword({
      email: email.trim(),
    });
  },
  resetPassword(_, { userId, resetCode, newPassword }) {
    return AccountsService.resetPassword({
      userId,
      resetCode,
      newPassword,
    });
  },
  changePassword(_, { currentPassword, newPassword }) {
    return AccountsService.changePassword({
      oldPassword: currentPassword,
      newPassword,
    });
  },
  logout({ commit }) {
    commit('CLEAR_USER_DATA');
  },
};

export const getters = {
  loggedIn(state) {
    return !!state.userJwt && !!state.user;
  },
  fullName({ user }) {
    if (!user || !user.firstName || !user.lastName) {
      return '';
    }
    return `${user.firstName} ${user.lastName}`;
  },
  isUserAdmin({ user }) {
    return user.role === 'Admin';
  },
};
